<template>
  <v-content class="pa-0 ma-0">
    <v-data-table
      v-if="notifications != null"
      :items="notifications"
      :headers="headers"
      disable-initial-sort
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <tr :key="props.index">
          <td class="text-xs-left">
            <a
              class="black--text"
              style="cursor: pointer"
              @click="handleNotification(props.item, true)"
              target="_self"
            >
              <v-flex
                class="notification__text font-weight-bold mr-1"
                v-if="props.item.company_id > 0"
              >
                {{ getNameAndUserOfCompany(props.item.company_id) }}
                <span class="grey--text notification__time">{{
                  props.item.text
                }}</span>
              </v-flex>
              <v-flex
                class="notification__text font-weight-bold mr-1"
                v-else-if="isReminder(props.item)"
              >
              </v-flex>
              <v-flex class="notification__text font-weight-bold mr-1" v-else>
                Soraban
                <span class="grey--text notification__time">{{
                  props.item.text
                }}</span>
              </v-flex>
            </a>
          </td>
          <td class="text-xs-left">
            {{ moment(props.item.created_at).fromNow() }}
          </td>
        </tr>
      </template>

      <template slot="no-data">
        <v-layout class="text-xs-center grey--text">
          <v-flex>
            <v-icon size="16" color="grey"> priority_high </v-icon>
            <span class="ml-1">None</span>
          </v-flex>
        </v-layout>
      </template>
    </v-data-table>
  </v-content>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'NotificationTable',
  props: {
    notifications: {
      type: Array,
    },
  },
  data() {
    return {
      moment,
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'title',
          width: '70%',
        },
        {
          text: 'Sent at',
          align: 'left',
          value: 'created_at',
          sortable: true,
          width: '30%',
        },
      ],
    };
  },
  methods: {
    handleNotification(notification, openInNewWindow) {
      this.$emit('handleNotification', notification, openInNewWindow);
    },
    getNameAndUserOfCompany(company_id) {
      let company = this.companies.find(c => c.id === company_id);

      if (company) {
        if (company.entity_type === 'Individual') {
          return `${company.user.full_name}`;
        } else {
          return `${company.name} (${company.user.full_name})`;
        }
      }
      return 'Missing Name';
    },
    isReminder(notification) {
      return notification.company_id === 0;
    },
  },
  computed: {
    ...mapState('companies', ['companies']),
  },
  watch: {},
};
</script>

<style lang="postcss" scoped></style>
